import { projectTemplates } from "../../assets/projectTemplates";
import CreateAppProject from "./CreateAppProject";

type Props = {
  selectedProjectForAppName: string | null;
  handleProjectSelection: (projectName: string) => void;
};

const CreateAppProjects = ({
  selectedProjectForAppName,
  handleProjectSelection
}: Props) => {
  return (
    <div className="grid grid-cols-[20%_1fr] gap-4">
      <span className="mt-2 text-right text-brand-gray-700 dark:text-brand-gray-100">
        Select a project
      </span>
      <span className="p-1 grid grid-cols-3 gap-2">
        {projectTemplates.map((project) => (
          <CreateAppProject
            key={project.id}
            project={project}
            handleProjectSelection={handleProjectSelection}
            selectedProjectForAppName={selectedProjectForAppName}
          />
        ))}
      </span>
    </div>
  );
};

export default CreateAppProjects;
